import _ from 'lodash'

import { IGanadorWithData } from '../../consejeros/types/ganadores'
import listas, { Lista } from '../../types/listas'
import partidos from '../../types/partidos'
import { Option } from '../ParticipationSection/ParticipationTable/ProgressBar'
import { IComparadorRechazo } from '.'
import { IPacto, IPartido } from './Pacto'

const LISTAS_RECHAZO = ['0', '2', '4'] as Lista[]

export const whiskerDataFormGanadoresWidData = ({
  ganadores,
  ratioRechazoPlebiscito,
}: IComparadorRechazo) => {
  const candidatosNoIndigenas = ganadores.filter(({ lista }) => lista !== '5')
  const totalVotos = _.sumBy(candidatosNoIndigenas, 'votos')
  const candidatosPorLista = _.groupBy(ganadores, 'lista')
  const barrasDerecha = LISTAS_RECHAZO.reduce((listasRechazo, lista) => {
    const ganadoresLista = candidatosPorLista[lista]
    if (ganadoresLista) {
      const votosLista = _.sumBy(ganadoresLista, 'votos')
      const ratioLista = totalVotos ? votosLista / totalVotos : 0
      return [
        ...listasRechazo,
        {
          color: listas[lista].color,
          key: lista,
          order: listas[lista].order,
          ratio: ratioLista,
        },
      ]
    }
    return listasRechazo
  }, [] as Option[])
  const ratioPartidosDerecha = _.sumBy(barrasDerecha, 'ratio')
  const ratioApruebo = 1 - ratioRechazoPlebiscito

  const getBarraApruebo = () => {
    const barraApruebo = {
      color: '#EEEEF0',
      key: 'apruebo',
      order: -2,
    }
    if (ratioRechazoPlebiscito !== 1) {
      if (ratioPartidosDerecha >= ratioRechazoPlebiscito) {
        return {
          ...barraApruebo,
          ratio: 1 - ratioPartidosDerecha,
        }
      } else {
        return {
          ...barraApruebo,
          ratio: ratioApruebo,
        }
      }
    }
  }

  const getBarraRestante = () => {
    if (ratioPartidosDerecha < ratioRechazoPlebiscito) {
      return {
        color: '#E0E0E0',
        key: 'brecha',
        order: -1,
        ratio: ratioRechazoPlebiscito - ratioPartidosDerecha,
      }
    }
  }

  const barraApruebo = getBarraApruebo()
  const barraRestante = getBarraRestante()
  const barrasApruebo = barraApruebo ? [barraApruebo] : []
  const barrasRestante = barraRestante ? [barraRestante] : []

  const barras: Option[] = [...barrasDerecha, ...barrasApruebo, ...barrasRestante].filter(
    (barra) => barra !== undefined
  )
  return {
    barras,
    ratioApruebo,
    ratioPartidosDerecha,
    ratioRechazoPlebiscito,
  }
}

export const partidosDataFromGanadores = ({ ganadores }: { ganadores: IGanadorWithData[] }) => {
  const candidatosNoIndigenas = ganadores.filter(({ lista }) => lista !== '5')
  const votosTotales = _.sumBy(candidatosNoIndigenas, 'votos')
  const groupedGanadores = _.groupBy(candidatosNoIndigenas, 'lista')
  const listasWithData = LISTAS_RECHAZO.reduce((dataLista, lista) => {
    const ganadoresLista = groupedGanadores[lista]
    const votosLista = _.sumBy(ganadoresLista, 'votos')
    const ratioLista = votosTotales ? votosLista / votosTotales : 0
    const { color, name, order, parties, shortName } = listas[lista]
    const groupedByPartido = _.groupBy(candidatosNoIndigenas, 'partido')
    const partidosListaData = parties.reduce((dataPartido, partido) => {
      const ganadoresPartido = groupedByPartido[partido]
      const partidoData = partidos[partido]
      const acronym = partidoData.acronym.replace('IND-', '')
      const previousPartidoData = dataPartido.find(({ sigla }) => sigla === acronym)
      const votosPartido = _.sumBy(ganadoresPartido, 'votos')
      const ratioByPartido = votosTotales ? votosPartido / votosTotales : 0
      if (previousPartidoData) {
        previousPartidoData.ratio += ratioByPartido
        return dataPartido
      }
      return [
        ...dataPartido,
        {
          ratio: ratioByPartido,
          sigla: acronym,
        },
      ]
    }, [] as IPartido[])
    return [
      ...dataLista,
      {
        color,
        nombre: name,
        order,
        partidos: partidosListaData,
        ratioLista,
        shortName,
        votosLista,
      },
    ]

    return dataLista
  }, [] as IPacto[])
    .sort(({ order: orderA }, { order: orderB }) => orderA - orderB)
  return listasWithData
}
